import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var label = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_xgjjxm8',variantClassNames:{required:{true:'fx_2d2fb1e5_xgjjxm9',false:'fx_2d2fb1e5_xgjjxma'}},defaultVariants:{},compoundVariants:[]});
var labelContent = 'fx_2d2fb1e5_xgjjxm7';
var labelRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_xgjjxm2',variantClassNames:{state:{'default':'fx_2d2fb1e5_xgjjxm3',error:'fx_2d2fb1e5_xgjjxm4'},withInField:{true:'fx_2d2fb1e5_xgjjxm5',false:'fx_2d2fb1e5_xgjjxm6'}},defaultVariants:{state:'default'},compoundVariants:[]});

export { label, labelContent, labelRoot };
//# sourceMappingURL=label.vanilla.mjs.map
